import React from 'react';
import { Card, DescriptionList, Text } from '@heartinternet/hi-ui';
import type { DescriptionListItem } from '@heartinternet/hi-ui';
import type { SSLInfoData } from '../types';
import { getCertificateName, getStatusName } from '../helpers';

export interface CertificateDetailsProps {
  info: SSLInfoData;
}

/** Certificate Details card — mirrors submitted/certificate-details.js. Always shown. */
export const CertificateDetails: React.FC<CertificateDetailsProps> = ({ info }) => {
  const items: DescriptionListItem[] = [];
  if (info.common_name) items.push({ label: 'Domain', value: info.common_name });
  if (info.display_name) items.push({ label: 'Display name', value: info.display_name });
  items.push({ label: 'Certificate ID', value: info.oid });
  if (info.provider) items.push({ label: 'Issuer', value: info.provider });
  items.push({ label: 'Status', value: getStatusName(info.status) });
  if (info.product_type)
    items.push({ label: 'Type', value: getCertificateName(info.product_type, info.is_wildcard) });

  return (
    <Card variant="surface" header={<Text variant="heading-3">Certificate details</Text>}>
      <div className="hi-ui-ssl-info__section-body">
        <Text variant="body">Here are the details of your SSL certificate.</Text>
        <DescriptionList layout="horizontal" items={items} />
      </div>
    </Card>
  );
};
